<div class="w-100 h-100" fxLayout="column" fxLayoutAlign="start start">
    <mat-sidenav-container class="w-100 h-100 bc-mono-white" hasBackdrop="false" autosize>
        <mat-sidenav mode="side" opened disableClose="true" [class.mw-240]="isDrawerOpen">
            <div class="w-100 pl-16 pr-16" fxLayout="column" fxLayoutAlign="start center">
                <div class="mh-72" fxLayout="row" fxLayoutAlign="center center">
                    @if (isDrawerOpen) {
                        <div class="t2-semi-bold">Antifraud center</div>
                    }
                    <ui-kit-svg matRipple
                                class="i-24 circle pointer"
                                [class.ml-8]="isDrawerOpen"
                                [name]="isDrawerOpen ? 'ic_drawer_close': 'ic_drawer_open'"
                                (click)="isDrawerOpen = !isDrawerOpen"
                                [matRippleCentered]="true"
                                [matRippleUnbounded]="true">
                    </ui-kit-svg>
                </div>
                @for (navLink of navLinks; track navLink; let first = $first) {
                    @if (authHolderService.hasAccess(navLink.roles) && !hasExcludedRole(navLink)) {
                        <div
                            class="pointer p-16 w-100"
                            [routerLink]="navLink.link"
                            routerLinkActive
                            #rla="routerLinkActive"
                            [class.bc-secondary-blue-200]="rla.isActive"
                            [class.radius-12]="rla.isActive"
                            [class.mt-16]="first"
                            fxLayout="row"
                            fxLayoutAlign="center center">
                            <ui-kit-svg matRipple
                                        class="i-24"
                                        [name]="navLink.icon"
                                        [matRippleDisabled]="isDrawerOpen"
                                        [matRippleCentered]="!isDrawerOpen"
                                        [matRippleUnbounded]="!isDrawerOpen"
                                        [class.dot-badge]="navLink.badge">
                            </ui-kit-svg>
                            @if (isDrawerOpen) {
                                <div fxLayout="row" fxLayoutAlign="start center" class="overflow-hidden ml-20" fxFlex>
                                    <div class="t2-semi-bold">{{ navLink.label | translate }}</div>
                                </div>
                            }
                        </div>
                    }
                }
                @if (authHolderService.hasAccess(['npck-admin', 'organization-supervisor'])) {
                    <div fxLayout="column" fxLayoutAlign="start center" class="w-100">
                        <div class="divider w-100 mt-16"></div>
                        <div
                            class="pointer p-16 mt-16 w-100 "
                            [routerLink]="Path.ADMIN_PANEL"
                            routerLinkActive
                            #rla="routerLinkActive"
                            [class.bc-secondary-yellow-100]="rla.isActive"
                            [class.radius-12]="rla.isActive"
                            fxLayout="row" fxLayoutAlign="center center">
                            <ui-kit-svg matRipple
                                        class="i-24"
                                        name="ic_menu_users"
                                        [matRippleDisabled]="isDrawerOpen"
                                        [matRippleCentered]="!isDrawerOpen"
                                        [matRippleUnbounded]="!isDrawerOpen">
                            </ui-kit-svg>
                            @if (isDrawerOpen) {
                                <div class="t2-semi-bold overflow-hidden ml-20"
                                     fxFlex>{{ 'i18n_af_menuAdminPanel' | translate }}
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </mat-sidenav>
        <mat-sidenav-content class="overflow-hidden">
            <div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-100">
                <div fxLayout="row" fxLayoutAlign="end center" class="w-100 header">

                    @if (showPasswordExpiryWarning) {
                        <div fxLayout="row" fxLayoutAlign="start center" class="mr-40">
                            <ui-kit-svg class="i-16 p-8 bc-secondary-yellow-200 c-secondary-yellow-900 radius-8"
                                        name="ic_warning">
                            </ui-kit-svg>
                            <div fxLayout="column" fxLayoutAlign="start space-between" class="t2-semi-bold ml-8">
                                <div>{{ 'i18n_af_labelPasswordExpiryWarning' | translate }}</div>
                                <div class="t6"
                                     [class.c-secondary-yellow-900]="!isLastAllowedDay"
                                     [class.c-secondary-red-900]="isLastAllowedDay">{{
                                        (isLastAllowedDay
                                            ? 'i18n_af_labelPasswordExpiryWarningTomorrow'
                                            : 'i18n_af_labelPasswordExpiryWarningDays') | translate: {count: passwordExpiryDaysLeft}
                                    }}
                                </div>
                            </div>
                        </div>
                    }

                    <div fxLayout="row" fxLayoutAlign="start center" class="mr-40 pointer"
                         (click)="openNotifications()">
                        <ui-kit-svg class="i-16 p-8 bc-primary-gray-50 c-primary-gray-900 radius-8"
                                    name="ic_notification">
                        </ui-kit-svg>
                        <div fxLayout="column" fxLayoutAlign="start space-between" class="t2-semi-bold ml-8">
                            <div>{{ 'i18n_af_labelNotifications' | translate }}</div>
                            <div class="t6"
                                 [class.c-primary-green-800]="notificationsCount"
                                 [class.c-primary-gray-600]="!notificationsCount">{{
                                    (notificationsCount
                                        ? 'i18n_af_labelNotificationsNewCount'
                                        : 'i18n_af_labelNotificationsNewZero') | translate: {count: notificationsCount}
                                }}
                            </div>
                        </div>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center">
                        <ui-kit-svg class="i-16 p-8 bc-primary-gray-50 radius-8" name="ic_user"></ui-kit-svg>
                        <div class="t2-semi-bold ml-8">{{ authHolderService.fullName | nameFormatter }}</div>
                    </div>
                    <div #popoverAnchor>
                        <ui-kit-svg matRipple
                                    class="i-16 p-8 pointer circle ml-16"
                                    name="ic_dots_menu"
                                    [matRippleCentered]="true"
                                    [matRippleUnbounded]="true"
                                    uiKitClickOutside
                                    (clickOutside)="popover.close()"
                                    (click)="popover.open()">
                        </ui-kit-svg>
                        <sat-popover #popover [anchor]="popoverAnchor" verticalAlign="below" horizontalAlign="end">
                            <div class="popover-container"
                                 fxLayout="column"
                                 fxLayoutAlign="start start">
                                <div fxLayout="row"
                                     fxLayoutAlign="start center"
                                     class="item"
                                     (click)="openChangePasswordDialog()">
                                    <ui-kit-svg class="i-16" name="ic_menu_reset_password"></ui-kit-svg>
                                    <div class="ml-8 t2 c-primary-gray-900">{{ 'i18n_af_resetPassword' | translate }}</div>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start center" class="item" (click)="logoutService.logout()">
                                    <ui-kit-svg class="i-16" name="ic_menu_logout"></ui-kit-svg>
                                    <div class="ml-8 t2 c-primary-gray-900">{{ 'i18n_af_logout' | translate }}</div>
                                </div>
                            </div>
                        </sat-popover>
                    </div>
                </div>
                <div class="w-100 h-100 bc-primary-gray-50 overflow-hidden">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
